<template lang="pug">
v-app
  Header(@open-drawer="openDrawer")
  UserMenuSide(
    v-if="user",
    :user="user",
    v-model="drawer"
  )
  v-content
    router-view
  Footer
</template>

<script>
import { mapState } from "vuex";
import Header from "@/components/layouts/Header.vue";
import Footer from "@/components/layouts/Footer.vue";
import UserMenuSide from "@/components/layouts/UserMenuSide.vue";

export default {
  name: "App",
  components: {
    Header,
    Footer,
    UserMenuSide
  },
  computed: {
    ...mapState({
      user: state => state.auth.user
    })
  },
  data() {
    return {
      drawer: false
    };
  },
  async beforeCreate() {
    let token = localStorage.getItem("auth_token");
    let user = JSON.parse(localStorage.getItem("user"));

    if (token && user && user.role.slug) {
      this.$store.commit("auth/setUser", user);
      this.$store.commit("auth/setTokenAuth", token);
    } else {
      if (!this.$route.path.match(/^\/auth\/\w+(\/\w+)?/g))
        this.$router.push("/auth/login");
    }
  },
  methods: {
    openDrawer(value) {
      this.drawer = value;
    }
  }
};
</script>
